{
  "nav": {
    "label": "Asosiy menyu",
    "reservoirs": "Suv omborlar",
    "noTenants": "Suv omborlari mavjud emas",
    "organizations": "Tashkilotlar",
    "settings": "Sozlamalar",
    "interfaceSettings": "Interfeys sozlamalari",
    "hotkeys": "Tezkor tugmalar",
    "guide": "Foydalanish qo’llanmasi",
    "collapse": "Menyuni yopish",
    "expand": "Menyuni ochish",
    "expandItem": "{{name}} — ochish",
    "collapseItem": "{{name}} — yopish",
    "groups": {
      "devices": "Qurilma boshqaruvi",
      "monitoring": "Monitoring",
      "employees": "Xodimlar",
      "connectors": "Konnektorlar",
      "documents": "Hujjatlar",
      "alarms": "Mezonlar",
      "constructor": "Konstruktor"
    },
    "items": {
      "deviceConfig": "Qurilma konfiguratsiya",
      "deviceCategories": "Qurilma turkumi",
      "deviceLocations": "Qurilma joylashgan o'rni",
      "deviceInfo": "Qurilma haqida ma'lumot",
      "deviceCalibration": "Qurilma kolibrovkalash",
      "charts": "Grafiklar boshqaruvi",
      "monitoringDevices": "Qurilma ma'lumoti",
      "monitoringPhysical": "Fizik ko'rsatkichlar",
      "monitoringVirtual": "Virtual ko'rsatkichlar",
      "employees": "Xodimlar boshqaruvi",
      "connectors": "Konnektorlar boshqaruvi",
      "documents": "Hujjatlar",
      "alarms": "Mezon monitoringi",
      "dashboard": "Bosh panel"
    }
  },
  "tabs": {
    "label": "Ochiq sahifalar",
    "home": "Bosh panel",
    "dashboardEdit": "Bosh panel sozlamasi",
    "sectionEdit": "Bo'lim sozlamasi",
    "section": "Bo'lim",
    "devices": "Qurilma konfiguratsiya",
    "charts": "Grafiklar boshqaruvi",
    "monitoring": "Ma'lumot monitoringi",
    "employees": "Xodimlar boshqaruvi",
    "connectors": "Konnektorlar boshqaruvi",
    "documents": "Hujjatlar",
    "alarms": "Mezon monitoringi",
    "settings": "Sozlamalar",
    "guide": "Foydalanish qo'llanmasi",
    "admin": "Tashkilotlar",
    "pin": "Mahkamlash",
    "unpin": "Mahkamlashni bekor qilish",
    "close": "Yopish",
    "unsaved": "Saqlanmagan o'zgarishlar bor",
    "scrollLeft": "Oldingi tablar",
    "scrollRight": "Keyingi tablar",
    "confirmClose": {
      "title": "O'zgarishlar saqlanmagan",
      "text": "«{{title}}» yopilsa, kiritilgan ma'lumotlar yo'qoladi.",
      "stay": "Qolish",
      "close": "Yopish"
    }
  },
  "pages": {
    "dashboardEdit": "Bosh panel sozlamasi",
    "sectionEdit": "Bo'lim sozlamasi",
    "deviceConfig": "Qurilma konfiguratsiya",
    "deviceCategories": "Qurilma turkumi",
    "deviceLocations": "Qurilma joylashgan o'rni",
    "deviceInfo": "Qurilma haqida ma'lumot",
    "deviceCalibration": "Qurilma kolibrovkalash",
    "charts": "Grafiklar boshqaruvi",
    "monitoringDevices": "Qurilma ma'lumoti",
    "monitoringPhysical": "Fizik ko'rsatkichlar monitoringi",
    "monitoringVirtual": "Virtual ko'rsatkichlar monitoringi",
    "employees": "Xodimlar boshqaruvi",
    "connectors": "Konnektorlar boshqaruvi",
    "documents": "Hujjatlar",
    "alarms": "Mezon monitoringi",
    "settings": "Sozlamalar",
    "interfaceSettings": "Interfeys sozlamalari",
    "hotkeys": "Tezkor tugmalar",
    "guide": "Foydalanish qo'llanmasi",
    "admin": "Tashkilotlar va suv omborlari"
  },
  "comingSoon": {
    "hint": "Bu sahifa ishlab chiqilmoqda va tez orada ishga tushadi."
  },
  "noAccess": {
    "title": "Ruxsat yo'q",
    "hint": "Bu sahifani ko'rish uchun sizda huquq yo'q. Administratorga murojaat qiling."
  },
  "user": {
    "menu": "Foydalanuvchi menyusi",
    "settings": "Sozlamalar",
    "logout": "Chiqish",
    "roles": {
      "platform_admin": "Asosiy admin",
      "org_admin": "Tashkilot admini",
      "tenant_admin": "Suv ombori admini",
      "tenant_member": "Xodim"
    }
  }
}
